import {ApiError} from "@/lib/api/api-error";

export class UserManagerApiError extends ApiError {
  public statusCode?: number
  public login?: boolean
  public twoFactorComplete: boolean

  constructor(
    message: string,
    login: boolean,
    twoFactorComplete: boolean,
    statusCode?: number
  ) {
    super(message)
    this.name = 'UserManagerApiError'
    this.login = login
    this.twoFactorComplete = twoFactorComplete
    this.statusCode = statusCode
  }
  
  public getLoginState() {
    return this?.login || false
  }
  
  public getTwoFactorCompleteState() {
    return this.twoFactorComplete
  }
}